module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "titlepage",
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "pl-author"
  }, [_vm._v("Noelle Marchand"), _c('br'), _vm._v("and"), _c('br'), _vm._v("Jan Drexler")]), _vm._v(" "), _c('p', {
    staticClass: "pl-title"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("The Texan’s"), _c('br'), _vm._v("Inherited Family"), _c('br'), _vm._v("&"), _c('br'), _vm._v("A Home for His Family")]), _vm._v(" "), _c('p', {
    staticClass: "pl-logo"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "height": "70",
      "src": "image/LI_2020.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c067a8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title_Page.vue
// module id = 60
// module chunks = 0